<template>
    <div class="tax-credit-invoice-advance-four-section-print-table">
        <div class="data-content">
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <td class="title">收入</td>
                        <td class="money-block">總計</td>
                        <td class="percentage">佔總收入%</td>
                    </tr>
                    <tr class="header-row">
                        <td class="title"></td>
                        <td class="money-block">
                            <Money :v="totalIncome" round />
                        </td>
                        <td class="percentage">100%</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in invoiceData" :key="item.iteM_SNO">
                        <td class="title">{{ item.iteM_NAM }}</td>
                        <td class="money-block">
                            <Money :v="getTotalAmt(item)" round />
                        </td>
                        <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                    </tr>
                </tbody>
            </table>
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <td class="title">成本</td>
                        <td class="money-block">總計</td>
                        <td class="percentage">佔總收入%</td>
                    </tr>
                    <tr class="header-row">
                        <td class="title"></td>
                        <td class="money-block">
                            <Money :v="totalCost" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalCost, totalIncome) }}%</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in costList" :key="item.iteM_SNO">
                        <td class="title">{{ item.iteM_NAM }}</td>
                        <td class="money-block">
                            <Money :v="getTotalAmt(item)" round />
                        </td>
                        <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                    </tr>
                </tbody>
            </table>
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <td class="title">稅前淨利</td>
                        <td class="money-block">總計</td>
                        <td class="percentage">佔總收入%</td>
                    </tr>
                    <tr class="header-row">
                        <td class="title"></td>
                        <td class="money-block">
                            <Money :v="totalNet" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalNet, totalIncome) }}%</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="title">＋收入</td>
                        <td class="money-block">
                            <Money :v="totalIncome" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalIncome, totalIncome) }}%</td>
                    </tr>
                    <tr>
                        <td class="title">－成本</td>
                        <td class="money-block">
                            <Money :v="totalCost" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalCost, totalIncome) }}%</td>
                    </tr>
                    <tr>
                        <td class="title">＝毛利</td>
                        <td class="money-block">
                            <Money :v="totalIncome - totalCost" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalIncome - totalCost, totalIncome) }}%</td>
                    </tr>
                    <tr>
                        <td class="title">－費用</td>
                        <td class="money-block">
                            <Money :v="totalFee" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalFee, totalIncome) }}%</td>
                    </tr>
                </tbody>
            </table>
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <td class="title">費用</td>
                        <td class="money-block">總計</td>
                        <td class="percentage">佔總收入%</td>
                    </tr>
                    <tr class="header-row">
                        <td class="title"></td>
                        <td class="money-block">
                            <Money :v="totalFee" round />
                        </td>
                        <td class="percentage">{{ getPercentage(totalFee, totalIncome) }}%</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in feeList" :key="item.iteM_SNO">
                        <td class="title">{{ item.iteM_NAM }}</td>
                        <td class="money-block">
                            <Money :v="getTotalAmt(item)" round />
                        </td>
                        <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        invoiceData: {
            type: Array,
            default: () => [],
        },
        paymentData: {
            type: Array,
            default: () => [],
        },
        salaryData: {
            type: Object,
            default: () => {},
        },
        isSalaryCost: Boolean,
    },
    computed: {
        totalIncome() {
            return _.sumBy(this.invoiceData, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
        totalNet() {
            return this.totalIncome - this.totalCost - this.totalFee;
        },
        costList() {
            const RETURN = _.chain(this.paymentData)
                .filter(['grP_NAM', 5])
                .value();
            if (this.isSalaryCost) {
                RETURN.push({
                    iteM_NAM: '薪資支出',
                    actuallyAmount: this.salaryData.salaryAmount + this.salaryData.bonusAmount,
                    nonProjectAmount: 0,
                    projectAmount: 0,
                    futureAmt: 0,
                });
            }
            return RETURN;
        },
        totalCost() {
            return _.sumBy(this.costList, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
        feeList() {
            const RETURN = _.chain(this.paymentData)
                .filter(['grP_NAM', 6])
                .value();
            RETURN.push({
                iteM_NAM: '人事費用',
                actuallyAmount: this.salaryData.staffCost,
                nonProjectAmount: 0,
                projectAmount: 0,
                futureAmt: 0,
            });
            if (!this.isSalaryCost) {
                RETURN.push({
                    iteM_NAM: '薪資支出',
                    actuallyAmount: this.salaryData.salaryAmount + this.salaryData.bonusAmount,
                    nonProjectAmount: 0,
                    projectAmount: 0,
                    futureAmt: 0,
                });
            }
            return RETURN;
        },
        totalFee() {
            return _.sumBy(this.feeList, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
    },
    methods: {
        getPercentage(value, total) {
            return Math.round((value / total) * 10000) / 100;
        },
        getTotalAmt(row) {
            return row.actuallyAmount + row.nonProjectAmount + row.projectAmount + row.futureAmt;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.tax-credit-invoice-advance-four-section-print-table {
    margin-top: 30px;
    width: 100%;
    line-height: 130%;
    font-size: 9pt;

    .data-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    table {
        width: 48%;
        font-weight: bold;
        margin-bottom: 30px;
        height: fit-content;

        td {
            padding: 0 20px;
            &:first-child,
            &:last-child {
                padding: 0;
            }
        }
        .percentage {
            width: 80px;
            text-align: right;
        }
        .title {
            width: 150px;
        }
        .money-block {
            text-align: right;
        }
        tr.header-row td {
            padding-bottom: 5px;
            border-bottom: 1px solid #eee;
        }
    }
    tbody tr:first-child td {
        padding-top: 5px;
    }
}
</style>
